/**
 * Content visibility hook used to control the visibility on each breakpoint
 * @param {Object} visibility - Visibility data for the content block
 * @param {Object} styles - (Optional) Existing styles for the hook
 * @returns {Object} Combined style object with responsive display settings
 */
export default function useContentVisibility(visibility, styles = {}) {
  const existingDisplay = styles.display ?? 'block';

  const visibilityDisplay = {};
  const activeBreakpoints = [];

  if (visibility && typeof visibility === 'object') {
    BREAK_POINTS.forEach((bp) => {
      const value = visibility[bp];
      if (value === true || value === false) {
        visibilityDisplay[bp] = value === true ? existingDisplay : 'none';
        activeBreakpoints.push(value);
      }
    });
  }

  const total = activeBreakpoints.length;
  const trueCount = activeBreakpoints.filter(Boolean).length;
  const falseCount = total - trueCount;

  if (total === 0) {
    return styles; // no valid breakpoints
  }

  let display;
  if (total === 1) {
    // Only one breakpoint defined
    display = activeBreakpoints[0] ? existingDisplay : 'none';
  } else if (trueCount === total) {
    // All defined breakpoints are true
    display = existingDisplay;
  } else if (falseCount === total) {
    // All defined breakpoints are false
    display = 'none';
  } else {
    // Mixed
    display = visibilityDisplay;
  }

  return {
    ...styles,
    display,
  };
}

const BREAK_POINTS = ['xs', 'sm', 'md', 'lg', 'xl'];
